import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { from, Observable } from 'rxjs';
import { DEFAULT_GET_LIMIT } from '../shared/constants/operationals';

export const VOP_REQUEST_API_NAME: string = 'vop_request';
export const VOP_REQUEST_API_ENDPOINT: string = environment.API_BASE_PATH + '/vop-request';

@Injectable({
  providedIn: 'root',
})
export class VopRequestService {
  createVopRequest(vop_request: VopRequest): Observable<any> {
    const api_name: string = VOP_REQUEST_API_NAME;
    const path: string = '';
    const init = {
      response: true,
      body: vop_request,
    };
    return from(API.post(api_name, path, init));
  }

  listVopRequest(list_params?: ListVopRequestParams): Observable<any> {
    const api_name: string = VOP_REQUEST_API_NAME;
    const path: string = '';

    let query_string_params: any = {
      cursor: list_params?.cursor || null,
      limit: list_params?.limit || DEFAULT_GET_LIMIT,
    };
    if (list_params?.vop_request_id) query_string_params['vop_request_id'] = list_params.vop_request_id;
    if (list_params?.status) query_string_params['status'] = list_params.status;
    if (list_params?.result) query_string_params['result'] = list_params.result;
    if (list_params?.beneficiary_firstname)
      query_string_params['beneficiary_firstname'] = list_params.beneficiary_firstname;
    if (list_params?.beneficiary_lastname)
      query_string_params['beneficiary_lastname'] = list_params.beneficiary_lastname;
    if (list_params?.beneficiary_tax_code)
      query_string_params['beneficiary_tax_code'] = list_params.beneficiary_tax_code;
    if (list_params?.beneficiary_iban) query_string_params['beneficiary_iban'] = list_params.beneficiary_iban;
    if (list_params?.order_id) query_string_params['order_id'] = list_params.order_id;
    if (list_params?.buyer_id) query_string_params['buyer_id'] = list_params.buyer_id;

    const init = { response: true, queryStringParameters: query_string_params };
    return from(API.get(api_name, path, init));
  }
}

export enum VopRequestStatus {
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
}

export enum VopRequestResult {
  CMTC = 'CMTC',
  MTCH = 'MTCH',
  NMTC = 'NMTC',
}

export enum VopRequestMostSimilarCall {
  fl_call = 'fl_call',
  lf_call = 'lf_call',
  tax_code_call = 'tax_code_call',
}

export interface VopRequest {
  vop_request_id?: string;
  status?: VopRequestStatus;
  result?: VopRequestResult;
  similiarity_score?: number;
  most_similar_call?: VopRequestMostSimilarCall;
  fl_call?: VopCall;
  lf_call?: VopCall;
  tax_code_call?: VopCall;
  error?: VopError;
  integration_call_id?: string;
  beneficiary_firstname?: string;
  beneficiary_lastname?: string;
  beneficiary_tax_code?: string;
  iban?: string;
  buyer_id?: string;
  buyer_email?: string;
  buyer_fullname?: string;
  buyer_tax_code?: string;
  store_id?: string;
  store_name?: string;
  store_email?: string;
  order_id?: string;
  company_id?: string;
  company_business_name?: string;
  succeeded_at?: number;
  failed_at?: number;
  created_at?: number;
  updated_at?: number;
}

export interface VopCall {
  request?: {
    istituto_codice?: string;
    applicazione_codice?: string;
    cliente_ordinante_iban?: string;
    cliente_beneficiario_iban?: string;
    cliente_beneficiario_nome?: string;
    cliente_beneficiario_codice_fiscale?: string;
    cliente_ordinante_ndg?: string;
    presentatore_ndg?: string;
  };
  status: 'pending' | 'succeeded' | 'failed';
  response?: {
    vop_id?: string;
    vop_id_progressivo?: number;
    cliente_beneficiario_controllo_nome_esito?: string;
    cliente_beneficiario_controllo_id_esito?: string;
    cliente_beneficiario_nome_suggerito?: string;
    cliente_beneficiario_nome_grado_di_similitudine?: number;
    cliente_beneficiario_stato_conto?: string;
    cliente_beneficiario_tipo_conto?: string;
    controllo_aggiuntivo_risultato?: string;
  };
  error?: {
    status?: string;
    code?: string;
    description?: string;
    timestamp?: string;
    detail_code?: string;
  };
}

export interface VopError {
  status?: number;
  code?: string;
  description?: string;
  timestamp?: string;
  detail_code?: string;
}

export interface ListVopRequestParams {
  vop_request_id?: string;
  order_id?: string;
  buyer_id?: string;
  status?: VopRequestStatus;
  result?: VopRequestResult;
  beneficiary_firstname?: string;
  beneficiary_lastname?: string;
  beneficiary_tax_code?: string;
  beneficiary_iban?: string;

  cursor?: string | null;
  limit?: number;
}

export interface DetailVopRequest {
  type: String;
  vop_call: VopCall;
  created_at?: number;
}
